import { Subject } from 'rxjs'
import apiResponse from '../../../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'

class UpdateBloc {

    updateChannel = new Subject()
    detailChannel = new Subject()
    trainingListChannel = new Subject()
    repository = new UpdateRepository()

    constructor() {
        this.updateChannel.next({ status: apiResponse.INITIAL })
        this.detailChannel.next({ status: apiResponse.INITIAL })
        this.trainingListChannel.next({ status: apiResponse.INITIAL })
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.updateChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchTrainingList = async (query) => {
        this.trainingListChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchTrainingList(query).then((result) => {
                this.trainingListChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.trainingListChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')  
        }
    }

}

export default UpdateBloc